import { DeleteOutlined, FormOutlined, PlusOutlined } from '@ant-design/icons'
import { Alert, Button, Card, Modal, Table } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { AdSizeBean, ItemResponseAdSizeBeanObject, ListPagination } from 'src/api/api'
import { toSort, useSorter } from 'src/util/useSorter'
import { StorageKey, storageReaderFactory, storageWriterFactory } from '../../../util/Storage'
import adSizeApi from './AdSizeApi'

const Column = Table.Column

const storageWriter = storageWriterFactory('AdSize')
const storageReader = storageReaderFactory('AdSize')

interface Props {
}

const AdSizeList: React.FC<Props> = () => {

    const [data, setData] = useState<AdSizeBean[]>([])
    const [pagination, setPagination] = useState<any>({
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: 1
    })
    const [error, setError] = useState()

    const loadData = async (page: number) => {
        const response = await adSizeApi.list(pagination.defaultPageSize, page, toSort(sorter))

        const array = response.data as Array<ItemResponseAdSizeBeanObject>
        const adSizeBeans: AdSizeBean[] = array.map(item => item.data as AdSizeBean)

        if (adSizeBeans.length == 0 && page > 1) {
            loadData(page - 1)
        } else {
            const newPagination: ListPagination = response.pagination as ListPagination
            storageWriter.write(StorageKey.SearchParams, {
                page: newPagination.currentPage
            })

            setData(adSizeBeans)
            setPagination({ ...pagination, total: newPagination.total, current: newPagination.currentPage })
        }
    }

    const { sorter, handleTableChange } = useSorter(pagination, loadData)

    useEffect(() => {
        const searchParams = storageReader.read(StorageKey.SearchParams)
        const page = searchParams.page || pagination.current

        loadData(page)
    }, [sorter])

    const remove = (record: AdSizeBean) => {
        Modal.confirm({
            title: `Delete ${record.name}?`,
            content: 'Are you sure?',
            cancelText: 'NO',
            okText: 'Yes, I\'m sure',
            onOk: async () => {
                try {
                    await adSizeApi.delete(record.id as number)

                    let page = pagination.current
                    if (data.length == 1 && pagination.current > 1) {
                        page -= 1
                    }

                    loadData(page)
                } catch (e) {
                    setError(e.error)
                }
            }
        })
    }

    return <Card
        title="Ad Size"
        className="list-card"
        extra={<Link to={`/ad-size/create`} className="create-new-link">
            <Button type="primary" htmlType="button" icon={<PlusOutlined />}>
                New Ad Size
            </Button>
        </Link>}
    >
        {error && <Alert message={error} type="error" />}
        <Table
            rowKey="id"
            size="middle"
            dataSource={data}
            pagination={{ ...pagination, size: 'default' }}
            onChange={handleTableChange}
        >
            <Column key="id" title="ID" dataIndex="id" sorter />
            <Column key="name" title="Name" dataIndex="name" sorter render={(text, record: AdSizeBean) => <Link to={`/ad-size/${record.id}/edit`}>{text}</Link>} />
            <Column key="size" title="Size" render={record => `${record.width}x${record.height}`} />
            <Column
                key="modified"
                title="Last Modified"
                dataIndex="modified"
                sorter
            />
            <Column align="center" key="action" title="Actions" render={(text: string, record: AdSizeBean) => (
                <span>
                    <Link to={`/ad-size/${record.id}/edit`}>
                        <Button type="text" >
                            <FormOutlined className="actions-btn" />
                        </Button>
                    </Link>
                    <Button type="text" danger onClick={() => remove(record)}>
                        <DeleteOutlined />
                    </Button>
                </span>
            )} />
        </Table>
    </Card>
}

export default AdSizeList


// WEBPACK FOOTER //
// ./src/component/app/adSize/AdSizeList.tsx